export default "__VITE_ASSET__DLqhdHHI__"